import React from 'react';
import { Input } from '../../ui/input';
import CommonFormFields from './CommonFormFields';

/**
 * Supply Run Form - Store runs and shopping errands
 */
const SupplyRunForm = ({ formData, setFormData }) => {
  const updateField = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4">
      <CommonFormFields formData={formData} setFormData={setFormData} />
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Store Information</h4>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">Store Name *</label>
          <Input
            value={formData.store_name || ''}
            onChange={(e) => updateField('store_name', e.target.value)}
            placeholder="e.g., Walmart, Target, Walgreens"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Store Type</label>
          <select
            value={formData.store_type || 'grocery'}
            onChange={(e) => updateField('store_type', e.target.value)}
            className="w-full p-3 border rounded-xl"
          >
            <option value="grocery">Grocery Store</option>
            <option value="pharmacy">Pharmacy</option>
            <option value="office_supply">Office Supply</option>
            <option value="retail">Retail Store</option>
            <option value="hardware">Hardware Store</option>
            <option value="other">Other</option>
          </select>
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Store Address (Optional)</label>
        <Input
          value={formData.store_address || ''}
          onChange={(e) => updateField('store_address', e.target.value)}
          placeholder="Specific location if known"
        />
      </div>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Shopping List</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Items Needed *</label>
        <textarea
          value={formData.shopping_list_text || ''}
          onChange={(e) => {
            setFormData({
              ...formData, 
              shopping_list_text: e.target.value,
              shopping_list: e.target.value.split('\n').filter(item => item.trim())
            });
          }}
          className="w-full p-3 border rounded-xl min-h-[120px]"
          placeholder="Enter each item on a new line:&#10;Milk&#10;Bread&#10;Eggs"
          required
        />
        <p className="text-xs text-[var(--text-muted)] mt-1">One item per line</p>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Additional Details</label>
        <textarea
          value={formData.shopping_list_details || ''}
          onChange={(e) => updateField('shopping_list_details', e.target.value)}
          className="w-full p-3 border rounded-xl min-h-[80px]"
          placeholder="Specific brands, sizes, quantities, etc."
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Brand Preferences</label>
        <Input
          value={formData.brand_preferences || ''}
          onChange={(e) => updateField('brand_preferences', e.target.value)}
          placeholder="e.g., Only organic, store brand OK"
        />
      </div>
      
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={formData.acceptable_substitutes !== false}
          onChange={(e) => updateField('acceptable_substitutes', e.target.checked)}
          className="w-4 h-4"
        />
        Substitutes OK if item unavailable
      </label>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Budget & Payment</h4>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">Estimated Budget ($) *</label>
          <Input
            type="number"
            value={formData.estimated_budget || ''}
            onChange={(e) => updateField('estimated_budget', parseFloat(e.target.value))}
            placeholder="Approximate total"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Payment Method</label>
          <select
            value={formData.payment_method || 'prepaid'}
            onChange={(e) => updateField('payment_method', e.target.value)}
            className="w-full p-3 border rounded-xl"
          >
            <option value="prepaid">Pay Upfront (Recommended)</option>
            <option value="reimburse">Reimburse Worker</option>
            <option value="card_on_file">Card on File</option>
          </select>
        </div>
      </div>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Delivery</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Delivery Address *</label>
        <Input
          value={formData.delivery_address || ''}
          onChange={(e) => updateField('delivery_address', e.target.value)}
          placeholder="Where to deliver groceries"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Delivery Instructions</label>
        <Input
          value={formData.delivery_instructions || ''}
          onChange={(e) => updateField('delivery_instructions', e.target.value)}
          placeholder="Gate code, leave at door, etc."
        />
      </div>
      
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={formData.leave_at_door || false}
          onChange={(e) => updateField('leave_at_door', e.target.checked)}
          className="w-4 h-4"
        />
        OK to leave at door
      </label>
    </div>
  );
};

export default SupplyRunForm;
